// extracted by extract-css-chunks-webpack-plugin
module.exports = {"bd":"bd-2oqNxMQd","space40":"space40-2rWVf9LX","space10":"space10-24GgNTEE"};